import { Flex, Heading, Text } from '@chakra-ui/react';
import { TransportRequest } from '@texas/api/endpoints/transportRequestApi';
import { Locale } from '@texas/i18n/types';
import { fadeInScaleAnimation } from '@texas/resources/animations/animations';
import { formatDate } from '@texas/utils/helpers/dateHelper';
import { useTranslation } from 'react-i18next';
import { RemoveComponent } from '../RemoveComponent';

export function TransportRequestItem({
  transport,
  onClick,
  onRemove,
  isSelected,
}: {
  transport: TransportRequest;
  onClick?: () => void;
  onRemove?: () => void;
  isSelected: boolean;
}) {
  const { t } = useTranslation();
  return (
    <RemoveComponent onClick={onRemove}>
      <Flex
        flexDir="column"
        gap={3}
        padding={4}
        bg="texas.bg.800"
        borderRadius="md"
        animation={fadeInScaleAnimation()}
        boxShadow="md"
        _light={{ bg: 'gray.50' }}
        {...(onClick
          ? {
              onClick: onClick,
              border: '1px solid transparent',
              transition: 'transform 200ms ease, border-color 100ms ease',
              _hover: { transform: 'scale(1)' },
              cursor: 'pointer',
            }
          : null)}
        {...(isSelected
          ? { borderColor: 'gray.300' }
          : { transform: 'scale(0.96)' })}
      >
        <Flex gap={4} justify="space-between" alignItems="baseline">
          <Text opacity={0.8}>
            {t('transportRequest.reqDispatchDateWithDate', {
              date: formatDate(Locale.En, transport.requestedDispatchDate),
            })}
          </Text>
          <Heading fontSize="xl" fontWeight="normal">
            #{transport.id}
          </Heading>
        </Flex>

        <Flex alignItems="center" gap={3}>
          <Text variant="sub" fontSize="sm">
            {t('general.to')}
          </Text>
          <Flex flexDir="column">
            <Text>{transport.receiverUser.name}</Text>
            <Text>{transport.receiverUser.email}</Text>
          </Flex>
        </Flex>
      </Flex>
    </RemoveComponent>
  );
}
